module.exports = __webpack_public_path__ + "static/media/background_800x900_20p_opaque.4ad1ebff.png";